import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Grid } from '@mui/material'

import Select from '../Select'
import { useSelectionSet } from '../../hooks/selection-set-functions'
import { getArePubblicati } from '../../hooks/utils-functions'
import { useGetCategorieQuery } from '../../hooks/api-slice'

const SelectCategoria = () => {
  const { admin } = useSelector(state => state.home.infoUtente)
  const { data: categorie } = useGetCategorieQuery()
  const availableCategorie = useSelector(
    state => state.selection.availableCategorie,
  )
  const selectedCategoria = useSelector(
    state => state.selection.selectedCategoria,
  )
  const selectedCampionatoGironiPubblicati = useSelector(
    state => state.selection.selectedCampionatoGironiPubblicati,
  )
  const selectedCampionatoCalendariPubblicati = useSelector(
    state => state.selection.selectedCampionatoCalendariPubblicati,
  )

  const location = useLocation()
  const arePubblicati = getArePubblicati(
    selectedCampionatoGironiPubblicati,
    selectedCampionatoCalendariPubblicati,
    location.pathname?.split('/')?.[1],
  )

  const { setSelectedCategoria } = useSelectionSet()

  const value = availableCategorie?.includes(selectedCategoria)
    ? selectedCategoria
    : undefined

  const optionLabels = [
    availableCategorie[0],
    ...availableCategorie
      ?.filter(a => a !== availableCategorie[0])
      ?.map(a => categorie?.find(c => c.categoria === a)?.nome),
  ]

  return (
    <Grid size={{ xs: 12, md: 3 }}>
      <Select
        id='available-categorie'
        label='Categoria'
        value={value}
        options={availableCategorie}
        optionLabels={optionLabels}
        autoSelect={false}
        disabled={!availableCategorie || (!admin && !arePubblicati)}
        onChange={setSelectedCategoria}
      />
    </Grid>
  )
}

export default SelectCategoria
